/**
* In head
*/

const head = document.getElementsByTagName("head")[0];
const scriptLiverampSync = document.createElement("script");

scriptLiverampSync.setAttribute("type", "text/javascript");
scriptLiverampSync.setAttribute("id", "liveramp-sync");
scriptLiverampSync.setAttribute("async", true);
scriptLiverampSync.setAttribute("src", "https://js-sec.indexww.com/ht/p/188801-78561911905477.js");
head.appendChild(scriptLiverampSync);
